import React, { useState } from "react";
import { isInReadOnlyMode } from "../../App";
import styled from "styled-components";
import smiley1Open from "../../resources/icons/smiley1-open.svg";
import smiley1Filled from "../../resources/icons/smiley1-filled.svg";
import smiley2Open from "../../resources/icons/smiley2-open.svg";
import smiley2Filled from "../../resources/icons/smiley2-filled.svg";
import smiley3Open from "../../resources/icons/smiley3-open.svg";
import smiley3Filled from "../../resources/icons/smiley3-filled.svg";
import smiley4Open from "../../resources/icons/smiley4-open.svg";
import smiley4Filled from "../../resources/icons/smiley4-filled.svg";
import smiley5Open from "../../resources/icons/smiley5-open.svg";
import smiley5Filled from "../../resources/icons/smiley5-filled.svg";
import { inter, Button } from "../../Theme";
import { device } from "../../constants/breakpoints";

function QuestionAnswerSmileyScale({question, answer, step, onPut, completed, ...props}) {
    const [selectedAnswer, setSelectedAnswer] = useState(answer ? parseInt(answer.value) : undefined);

    return (
        <QuestionAnswerSmileyScaleRoot>
            <SmileyWrapper>
                <SmileyButton
                    isActive={!isInReadOnlyMode() && !completed}
                    answerValue={1}
                    isSelected={selectedAnswer === 1}
                    step={step}
                    icon={smiley1Open}
                    iconFilled={smiley1Filled}
                    aria-label="Erg negatief"
                    aria-pressed={selectedAnswer === 1}
                    onClick={() => handleAnswerClick(question.id, 1)}
                />

                <SmileyButton
                    isActive={!isInReadOnlyMode() && !completed}
                    answerValue={2}
                    isSelected={selectedAnswer === 2}
                    step={step}
                    icon={smiley2Open}
                    iconFilled={smiley2Filled}
                    aria-label="Beetje negatief"
                    aria-pressed={selectedAnswer === 2}
                    onClick={() => handleAnswerClick(question.id, 2)}
                />

                <SmileyButton
                    isActive={!isInReadOnlyMode() && !completed}
                    answerValue={3}
                    isSelected={selectedAnswer === 3}
                    step={step}
                    icon={smiley3Open}
                    iconFilled={smiley3Filled}
                    aria-label="Neutraal"
                    aria-pressed={selectedAnswer === 3}
                    onClick={() => handleAnswerClick(question.id, 3)}
                />

                <SmileyButton
                    isActive={!isInReadOnlyMode() && !completed}
                    answerValue={4}
                    isSelected={selectedAnswer === 4}
                    step={step}
                    icon={smiley4Open}
                    iconFilled={smiley4Filled}
                    aria-label="Beetje positief"
                    aria-pressed={selectedAnswer === 4}
                    onClick={() => handleAnswerClick(question.id, 4)}
                />

                <SmileyButton
                    isActive={!isInReadOnlyMode() && !completed}
                    answerValue={5}
                    isSelected={selectedAnswer === 5}
                    step={step}
                    icon={smiley5Open}
                    iconFilled={smiley5Filled}
                    aria-label="Erg positief"
                    aria-pressed={selectedAnswer === 5}
                    onClick={() => handleAnswerClick(question.id, 5)}
                />
            </SmileyWrapper>
            <LabelWrapper>
                <LabelText>{question.labelLeft}</LabelText>
                <LabelText $right>{question.labelRight}</LabelText>
            </LabelWrapper>
        </QuestionAnswerSmileyScaleRoot>
    );

    function SmileyButton({step, icon, iconFilled, ...props}) {
        return (
            <SmileyButtonRoot
                $pinkOutline
                $isActive={props.isActive}
                $selected={props.isSelected}
                onClick={props.onClick}
                aria-label={props["aria-label"]}
                aria-pressed={props["aria-pressed"]}
            >
                <SmileyIcon src={icon} alt="Smiley Icon"/>
                <SmileyIconFilled src={iconFilled} $selected={props.isSelected} alt="Smiley Icon"/>
            </SmileyButtonRoot>
        );
    }

    function handleAnswerClick(questionId, answerValue) {
        const answerId = answer ? answer.id : ""
        const answerData = {
            id: answer ? answer.id : null,
            questionId: questionId,
            periodId: props.periodId,
            value: answerValue
        }

        putAnswer(answerData, answerValue, answerId);
    }

    function putAnswer(answerData, answerValue, answerId) {
        onPut(answer, answerData)
        setSelectedAnswer(answerValue);
    }
}

const SmileyIcon = styled.img`
    width: 61px;
    height: 61px;
`;

const SmileyIconFilled = styled(SmileyIcon)`
    display: ${({$selected}) => $selected ? "block" : "none"};
`;

export const SmileyButtonRoot = styled(Button)`
    background: transparent;
    width: 61px;
    height: 61px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    pointer-events: ${({$isActive}) => $isActive ? 'default' : 'none'};
    cursor: pointer;

    ${SmileyIcon} {
        display: ${({$selected}) => $selected ? "none" : "block"};
        filter: ${({$isActive}) => !$isActive && "grayscale(100%) contrast(0.0)"};
        opacity: ${({$isActive}) => !$isActive && "0.8"};
    }

    ${SmileyIconFilled} {
        display: ${({$selected}) => $selected ? "block" : "none"};
    }
    
    &:hover ${SmileyIcon} {
        display: none;
    }

    &:hover ${SmileyIconFilled} {
        display: block;
    }

    @media screen and ${device.mobileL} {
        width: 44px;
        height: 44px;
        
        img {
            width: 44px;
            height: 44px;
        }
    }
`;

const SmileyWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

const LabelWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    gap: 24px;
`

const LabelText = styled.div`
    font-family: ${inter};
    font-size: 12px;
    font-weight: 400;
    flex-basis: 50%;
    opacity: 0.7;
    
    text-align: ${({$right}) => $right ? "right" : "left"};
`

export const QuestionAnswerSmileyScaleRoot = styled.div`
    display: flex;
    flex-direction: column;
`;

export default QuestionAnswerSmileyScale;